import { observer } from 'mobx-react-lite';
import { Markup } from 'react-render-markup';
import './index.scss';
import { useState, useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { getCategories as getCategoriesApi, getSubcategoryContent as getSubcategoryContentApi } from '@api/service-rules-api';


const ServiceRulesPage = observer(() => {
    const [ categories, setCategories ] = useState([]);
    const [ content, setContent ] = useState('<h1><p><b>Bu bölmədə SquadDevs xidməti haqqında bütün əsas məlumatları tapacaqsınız.</b></h1> </p>' +
        '<p>Sol menyudan istifadə edərək hüquqi məlumatları, xidmətin iş qaydalarını və sifarişçilər və freelancerlər üçün tövsiyələri öyrənə bilərsiniz.</p>' +
        '<p>Ümid edirik ki, bu biliklər sizə IT mütəxəssisləri üçün SquadDevs xidməti ilə uzun və məhsuldar əməkdaşlıqda kömək edəcək.</p>' +
        '<p><b>Kiçik ipucu:</b> əgər bu bölmədə lazımi məlumatı tapmasanız, <b>' + 
        '<a href="https://squadDevs.com/faq" >FAQ</b></a> bölməsinə baxmağa çalışın.</p>' +
        '<p>Orada da yoxdur? O zaman bütün suallarınızı poçt vasitəsilə cavablandırmağa hazırıq: <b>info@squaddevs.com</b> .</p>');
    const [ activeSubcategoryId, setActiveSubcategoryId ] = useState(0);
    
    useEffect(() => {
        const getCategories = async () => {
            getCategoriesApi()
            .then((res) => {
                console.log(res.data);
                setCategories(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
            // console.log(result.results);
        }
        getCategories();
    }, []);

    const getContent = (id) => {
        setActiveSubcategoryId(id);
        const getSubcategoryContent = async () => {
            getSubcategoryContentApi(id)
            .then((res) => {
                if (res.data && res.data.content) {
                    setContent(res.data.content);
                } else {
                    setContent('');
                }
            })
            .catch((error) => {
                setContent('');
                console.log(error);
            });
            // console.log(result.results);
        }
        getSubcategoryContent();
    }

    return (
        <div className="service-rules-page">
            <div className="container">
                <div className="main">
                    <div className="row gy-3">
                        <div className="col-lg-4">
                            <div className="left-block">
                            <Accordion defaultActiveKey="0">
                            {
                                categories.length > 0 && categories.map((c, i) => {
                                    return (
                                        <Accordion.Item eventKey={i} key={c.id}>
                                            <Accordion.Header>{c.name}</Accordion.Header>
                                            <Accordion.Body>
                                                {
                                                    c.subcategories.length > 0 && c.subcategories.map(s => {
                                                        return (
                                                            <div key={s.id} className={"subcategory " + (activeSubcategoryId === s.id ? "active-subcategory" : "")} 
                                                                onClick={() => getContent(s.id)}>{s.name}</div>
                                                        );
                                                    })
                                                }
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    );
                                })
                            }
                            </Accordion>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="right-block">
                                <Markup markup={content} />
                                {/* {content} */}
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
})

export { ServiceRulesPage }